import { Vec2 } from '../math/Vec2';
import { BALL } from '../config/constants';

export class Ball {
  pos: Vec2;
  vel: Vec2;
  radius: number = BALL.RADIUS;
  color: string = '#ffffff';
  isMain: boolean;
  isSmashed: boolean = false;
  normalSpeed: number = BALL.INITIAL_SPEED;
  spin: number = 0;
  lastHitterId: string | null = null;
  lifespanTicks: number; // -1 for main ball, >0 for temporary balls
  isDead: boolean = false;
  trail: Array<{ pos: Vec2; color: string }> = [];
  hitHistory: string[] = []; // Stores recent paddle IDs for anti-stall

  constructor(pos: Vec2, isMain: boolean = true) {
    this.pos = pos.clone();
    this.vel = Vec2.zero();
    this.isMain = isMain;
    this.lifespanTicks = isMain ? -1 : BALL.TEMP_BALL_TICKS;
  }

  get speed(): number {
    return this.vel.length();
  }

  launch(targetAngle: number, speed: number = BALL.INITIAL_SPEED): void {
    this.vel = Vec2.fromAngle(targetAngle, speed);
    this.isDead = false;
    this.color = '#ffffff';
    this.isSmashed = false;
    this.lastHitterId = null;
    this.spin = 0;
    this.trail = [];
  }

  update(): void {
    if (this.isDead) return;

    // Temporary balls countdown
    if (!this.isMain && this.lifespanTicks > 0) {
      this.lifespanTicks--;
      if (this.lifespanTicks <= 0) {
        this.isDead = true;
        return;
      }
    }

    const currentSpeed = this.speed;

    // Magnus Effect: curved trajectory based on spin
    if (currentSpeed > 0 && Math.abs(this.spin) > 0.05) {
      const perp = new Vec2(-this.vel.y / currentSpeed, this.vel.x / currentSpeed);
      this.vel = this.vel.add(perp.scale(this.spin * BALL.MAGNUS_FORCE));

      // Preserve original speed (Magnus curves direction without acceleration)
      const newSpeed = this.vel.length();
      if (newSpeed > 0) {
        this.vel = this.vel.scale(currentSpeed / newSpeed);
      }

      this.spin *= BALL.SPIN_DAMPING;
    }

    // Trail recording
    this.trail.push({ pos: this.pos.clone(), color: this.color });
    if (this.trail.length > 20) {
      this.trail.shift();
    }

    // Move
    this.pos = this.pos.add(this.vel);
  }

  applySpin(paddleSpeedPixels: number): void {
    this.spin = this.spin * 0.4 + paddleSpeedPixels * 0.8;
    this.spin = Math.max(-BALL.MAX_SPIN, Math.min(BALL.MAX_SPIN, this.spin));
  }
}
